import { useInfiniteQuery } from '@tanstack/react-query';
import axios from 'axios';

const fetchFeedPosts = async (
  feed,
  pageId,
  ranking,
  limit,
  pageParam,
  isPreviousPage,
) => {
  const response = await axios.get(`${process.env.REACT_APP_FEED_SERVER}/feeds`, {
    params: {
      feedName: feed.name,
      feedId: feed.id,
      pageId: pageParam?.pageParam || pageId,
      ranking,
      limit,
      isPreviousPage,
    },
  });
  return response.data;
};

export default function useFeedPosts(feed: { name: string, id: string }, pageId?: string, ranking: string = '', limit: number = 10, extraQueryKeys: any[] = []) {
  const queryKey = ['useFeedPosts', feed, ranking, limit, ...extraQueryKeys];

  return useInfiniteQuery({
    queryKey,
    queryFn: ({ pageParam, meta }) => {
      const isPreviousPage = meta?.isPreviousPage || false;
      return fetchFeedPosts(
        feed,
        pageId,
        ranking,
        limit,
        pageParam,
        isPreviousPage,
      );
    },
    enabled: !!(typeof pageId === 'string'),
    staleTime: 0,
    cacheTime: 0,
    refetchOnMount: true,
    getPreviousPageParam: (lastPage) => {
      if (lastPage.results.length) {
        return {
          pageParam: lastPage.results[0].id,
          meta: { isPreviousPage: true },
        };
      }
      return undefined;
    },
    getNextPageParam: (lastPage) => {
      if (lastPage.results.length && lastPage.next) {
        return {
          pageParam: lastPage.results[lastPage.results.length - 1].id,
          meta: { isPreviousPage: false },
        };
      }
      return undefined;
    },
  });
}
